export const getUserAccounts = `query getUser{
  getUser{
      accounts {
          type
          number
      }
  }
}`;
